<template>
  <div>
    <div class="search-area" :style="{'min-height':minHeight+'px'}">
      <Header ref="headerLine" :showSearch="false"></Header>
      <div class="search-box">
        <b-container fluid>
          <b-row>
            <b-col xl="12">
              <!-- pc -->
              <div class="d-sm-none d-xl-block">
                <div class="search-line flex">
                  <div class="search-left flex align-center justify-center" @click="back">
                    <img src="../../assets/image/icon19.png">
                  </div>
                  <div class="search-right flex">
                    <div class="search-input">
                      <el-input v-model="keyword" placeholder="输入搜索关键字" @keydown.enter.native.prevent="resetSearch" />
                    </div>
                    <div class="search-btn flex align-center justify-center" @click="resetSearch">
                      <img src="../../assets/image/icon20.png">
                    </div>
                  </div>
                </div>
              </div>
              <!-- h5 -->
              <div class="d-xl-none d-sm-block">
                <div class="sm-search-line flex search-line justify-between">
                  <div class="search-input flex">
                    <el-input v-model="keyword" placeholder="输入搜索关键字" @keydown.enter.native.prevent="resetSearch">
                      <template slot="prefix">
                        <div class="prefix-box" @click="cleanSearch">
                          <img src="../../assets/image/icon22.png" />
                        </div>
                      </template>
                    </el-input>
                    <div class="search-btn" @click="resetSearch">搜索</div>
                  </div>
                  <div class="search-reset">
                    <img src="../../assets/image/icon21.png" @click="back" />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="list.length!=0">
            <b-col xl="12">
              <div class="search-result-area flex justify-end">
                <div class="search-result-box flex flex-column justify-between">
                  <div class="result-list flex flex-column">
                    <div class="result-list-item" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
                      <div class="result-list-item-title" v-html="item.title">
                      </div>
                      <div class="result-list-item-content overHidden2" v-html="item.desc">
                      </div>
                      <div class="result-list-item-source">来自：{{ item.categoryOneName }}>{{ item.categoryTwoName }}</div>
                    </div>
                  </div>
                  <div class="pageination">
                    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="size" layout="pager,next,total" :total="total">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <Footer></Footer>
    <!-- 提示框 -->
    <el-dialog :visible.sync="visible" width="220px" :modal="false">
      <div class="no-error-area">
        <div class="error-icon flex align-center justify-center">
          <i class="el-icon-warning" />
        </div>
        <div class="error-title">{{dialogType==0?'请输入搜索关键词!':'暂无搜索结果'}}</div>
      </div>
    </el-dialog>
  </div>

</template>
<script>
import pagination from "@/components/pagination"
import { searchByKey } from "@/api/index"
import { replaceKeywordColor } from "@/utils/utils"
export default {
  components: { pagination },
  data() {
    return {
      currentPage: 1,
      total: 0,
      minHeight: 0,
      keyword: null,
      size: 5,
      searchParams: null,
      list: [],
      visible: false,
      dialogType: 0
    }
  },
  created() {
    let minHeight = Math.max(934, (document.documentElement.clientHeight || document.body.clientHeight - 353))
    this.minHeight = minHeight
    if (minHeight > 934) {
      this.size = 10
    }
  },
  mounted() {
    this.countViewCount()
  },
  methods: {
    handleCurrentChange(current) {
      this.currentPage = current
      this.searchList()
    },
    back() {
      this.$router.back()
    },
    resetSearch() {
      this.currentPage = 1
      this.searchParams = null
      this.list = []
      this.searchList()
    },
    cleanSearch() {
      this.$router.back()
    },
    searchList() {
      if (this.keyword == '' || this.keyword == undefined) {
        // this.$message.warning('请输入搜索关键词!')
        this.dialogType = 0
        this.visible = true
        return
      }
      let params = {}
      if (this.searchParams) {
        params = { ...this.searchParams }
        params.pageNum = this.currentPage
      } else {
        params = {
          keyName: this.keyword,
          pageNum: this.currentPage,
          pageSize: this.size
        }
      }
      searchByKey(params).then(res => {
        if (res.code == 200) {
          if (res.total == 0) {
            this.dialogType = 1
            this.visible = true
            return
          }
          this.total = res.total
          let key = this.keyword.trim()
          let temp = res.rows.map(v => {
            v.desc = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
            if (v.categoryTwoName == '中心资讯') {
              v.categoryTwoName = '中心资讯'
            }
            if (v.categoryTwoName == '招聘广告') {
              v.categoryTwoName = '招聘公告'
            }
            let firstPos = v.desc.indexOf(key)
            if (firstPos > 40) {
              let tempstr = v.desc.substring(firstPos - 8)
              v.desc = '...' + tempstr
            }
            v.title = replaceKeywordColor(v.title, key, '#3B7AF4')
            v.desc = replaceKeywordColor(v.desc, key, '#3B7AF4')
            return v
          })
          this.list = temp
          this.searchParams = { ...params }
        }
      })
    },
    goDetail(item) {
      if (item.categoryOneName != '人才招聘') {
        let tyepObject = {
          '新闻动态': 'news',
          '组织建设': 'orga',
          '业务领域': 'bussiness'
        }
        let type = tyepObject[item.categoryOneName]
        let AllScrollList = {
          news: { '中心资讯': 0, '最新新闻': 1, '行业动态': 2, '通知公告': 3 },
          orga: { '党群动态': 0, '党建活动': 1, '培训学习': 2 },
          bussiness: { '产品与服务': 0, '技术与创新': 1, '行业动向': 2 }
        }
        let scroll = AllScrollList[type][item.categoryTwoName]
        this.$router.push({ path: `/newsDetail?contentId=${item.id}&type=${type}&=pageName=${item.categoryTwoName}&scroll=${scroll}` })
      } else {
        let typeList = { '招聘公告': 0, '结果公示': 1 }
        this.$router.push({ path: '/recruitDetail?id=' + item.id + '&type=' + typeList[item.categoryTwoName] })
      }
    },
    cleanKeyword() {
      this.keyword = ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.visible = false
        }, 1500)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.search-area {
  //   height: calc(100vh - 353px);
  background-image: url("../../assets/image/bg28.png");
  background-size: cover;
  //   min-height: 810px;
  //   min-height: 934px;
  padding-top: 120px;
  padding-bottom: 60px;
  .search-box {
    // max-width: 1250px;
    max-width: 1280px;
    // height: 400px;
    // background: red;
    margin: 0 auto;
    .search-line {
      .search-left {
        width: 64px;
        height: 64px;
        background: #3b7af4;
        margin-right: 8px;
        flex-shrink: 0;
        cursor: pointer;
        img {
          width: 26px;
          height: 26px;
        }
      }
      .search-right {
        flex: 1;
        .search-input {
          flex: 1;
          min-width: 0;
          /deep/.el-input__inner {
            font-family: "SourceHanSansCN-Regular";
            width: 100%;
            height: 64px;
            background: rgba(255, 255, 255, 0.44);
            border: 1px solid rgba(59, 122, 244, 0.44);
            border-radius: 0px;
            font-size: 16px;
            color: #333333;
          }
          /deep/.el-input__inner::placeholder {
            font-family: "SourceHanSansCN-Regular";
            font-size: 16px;
            color: #333333;
          }
        }
        .search-btn {
          width: 80px;
          height: 64px;
          background: #3b7af4;
          flex-shrink: 0;
          cursor: pointer;
          img {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
    // h5-搜索栏
    .sm-search-line {
      width: 100%;
      .search-input {
        width: 88%;
        .prefix-box {
          img {
            width: 63px;
            height: 64px;
          }
        }
        .el-input {
          // max-width: 525px;
          width: 100%;
        }
        /deep/.el-input__inner {
          padding-left: 70px;
          width: 100%;
          // max-width: 525px;
          width: 100%;
          height: 64px;
          border-radius: 0px;
          font-size: 28px;
          color: #333333;
          background: #ffffff;
          border: 2px solid #3b7af4;
          font-family: "SourceHanSansCN-Regular";
        }
        /deep/.el-input__inner::placeholder {
          font-family: "SourceHanSansCN-Regular";
          font-size: 28px;
          color: #999999;
        }
        .search-btn {
          width: 88px;
          height: 64px;
          line-height: 64px;
          text-align: center;
          font-size: 24px;
          font-family: "SourceHanSansCN-Regular";
          color: #fff;
          background: #3b7af4;
        }
      }
      .search-reset {
        width: 64px;
        height: 64px;
        cursor: pointer;
        img {
          width: 64px;
          height: 64px;
        }
      }
    }
    // 搜索结果
    .search-result-area {
      width: 100%;
      margin-top: 20px;
      .search-result-box {
        width: 100%;
        max-width: 1180px;
        background: #fff;
        padding: 15px;
        // min-height: 582px;
        min-height: 696px;
        .result-list-item {
          padding: 10px 0;
          cursor: pointer;
          .result-list-item-title {
            font-family: "SourceHanSansCN-Regular";
            font-size: 24px;
            color: #333333;
            line-height: 36px;
          }
          .result-list-item-content {
            font-family: "SourceHanSansCN-Regular";
            font-size: 20px;
            color: #666666;
            line-height: 33px;
            margin: 5px 0 3px 0;
            word-wrap: break-word;
            min-height: 46px;
          }
          .result-list-item-source {
            font-family: "SourceHanSansCN-Regular";
            font-size: 14px;
            color: #999999;
            line-height: 21px;
          }
        }
        .pageination {
          margin-top: 40px;
          text-align: center;
          /deep/.number {
            background: #fff;
            border: 1px solid rgba($color: #999, $alpha: 0.5);
          }
          /deep/.active {
            border: none;
            color: #3b7af4;
          }
        }
      }
    }
  }
}
// 606266
/deep/.el-dialog {
  background-color: #606266;
  border-radius: 20px;
  opacity: 0.7;

  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/deep/.el-dialog__body {
  padding-top: 20px;
  padding-bottom: 20px;
}
/deep/.el-dialog__header {
  padding: 0;
}
// 错误提示
.no-error-area {
  .error-icon {
    width: 100%;
    min-height: 70px;
    i {
      color: #fff;
      width: 48px;
      height: 48px;
      font-size: 56px;
    }
  }
  .error-title {
    color: #fff;
    font-size: 20px;
    text-align: center;
    margin-top: 10px;
  }
}

// 移动端
@media (min-width: 576px) and (max-width: 1200px) {
  .col-xl-12 {
    padding: 0 24px;
  }

  .result-list-item {
    padding: 10px 0;
    cursor: pointer;
    .result-list-item-title {
      font-family: "SourceHanSansCN-Regular";
      font-weight: bold;
      font-size: 26px;
      color: #333333;
      line-height: 39px;
    }
    .result-list-item-content {
      font-family: "SourceHanSansCN-Regular";
      font-size: 24px;
      color: #666666;
      line-height: 36px;
      margin: 5px 0 3px 0;
      word-wrap: break-word;
      min-height: 76px;
    }
    .result-list-item-source {
      font-family: "SourceHanSansCN-Regular";
      font-size: 20px;
      color: #999999;
      line-height: 30px;
    }
  }
  /deep/.el-dialog {
    width: 350px !important;
  }
  .no-error-area {
    .error-icon {
      min-height: 120px;
      i {
        width: 80px;
        font-size: 80px !important;
      }
    }
    .error-title {
      font-size: 36px;
    }
  }
}
</style>